// extracted by mini-css-extract-plugin
export default {"selectedLanguage":"_3X5OS _2AZKg"};